import { useViewport } from "@bindeleddet/core/hooks";

import logo from "../../../assets/images/bindeleddetLogo/BL_heads_white.png";
import { FOOTER_BREAKPOINT } from "../constants";

import { StyledFooterBrand, BrandHeader, BrandLogo, BrandTitle, BrandParagraph } from "./FooterBrand.styled";

const FooterBrand = () => {
  const { width } = useViewport();

  return (
    <StyledFooterBrand span={width < FOOTER_BREAKPOINT ? 24 : 15}>
      <BrandHeader>
        <BrandLogo src={logo} alt="Bindeleddet Heads" />
        <BrandTitle>Bindeleddet NTNU</BrandTitle>
      </BrandHeader>

      <BrandParagraph>
        Studentorganisasjonen Bindeleddet NTNU sikrer kontakt mellom studenter ved Industriell økonomi og
        teknologiledelse og næringslivet. Organisasjonen ble opprettet og er drevet av studenter fra samme
        studieprogram.
      </BrandParagraph>
    </StyledFooterBrand>
  );
};

export default FooterBrand;
